var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { duration: 300 } }, [
    _vm.selection.length > 0
      ? _c(
          "div",
          { staticClass: "TicketBatchOperationBar" },
          [
            _c(
              "el-button",
              {
                attrs: { title: "批量回复勾选的工单" },
                on: { click: _vm.batchReply }
              },
              [_vm._v("批量回复")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的状态更新为已关闭" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdateStatus(6)
                  }
                }
              },
              [_vm._v("批量关闭")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的状态更新为已解决" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdateStatus(5)
                  }
                }
              },
              [_vm._v("已解决")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的状态更新为处理中" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdateStatus(3)
                  }
                }
              },
              [_vm._v("处理中")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的状态更新为待受理" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdateStatus(2)
                  }
                }
              },
              [_vm._v("待受理")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的优先级更新为紧急(P5)" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdatePriority(5)
                  }
                }
              },
              [_vm._v("紧急(P5)")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的优先级更新为P4" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdatePriority(4)
                  }
                }
              },
              [_vm._v("P4")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的优先级更新为P3" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdatePriority(3)
                  }
                }
              },
              [_vm._v("P3")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的优先级更新为P2" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdatePriority(2)
                  }
                }
              },
              [_vm._v("P2")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量将勾选的工单的优先级更新为一般(P1)" },
                on: {
                  click: function($event) {
                    return _vm.batchUpdatePriority(1)
                  }
                }
              },
              [_vm._v("一般(P1)")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量受理工单" },
                on: { click: _vm.batchAccept }
              },
              [_vm._v("批量受理")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量修改工单类型" },
                on: { click: _vm.batchUpdateTicketType }
              },
              [_vm._v("修改类型")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { title: "批量指派工单" },
                on: { click: _vm.batchAssign }
              },
              [_vm._v("指派")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { float: "right", "margin-right": "250px" },
                attrs: { title: "取消选择所有工单" },
                on: { click: _vm.onClose }
              },
              [_vm._v("取消选择")]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "批量回复",
                  visible: _vm.batchReplyDialogVisible,
                  "close-on-press-escape": false,
                  "close-on-click-modal": false,
                  width: "60%"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.batchReplyDialogVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      "padding-left": "10px",
                      "padding-right": "10px"
                    },
                    attrs: { inline: true }
                  },
                  [
                    _c("EditorSummernote", {
                      model: {
                        value: _vm.replyContent,
                        callback: function($$v) {
                          _vm.replyContent = $$v
                        },
                        expression: "replyContent"
                      }
                    }),
                    _vm._v(" "),
                    _c("TicketUploadList", {
                      ref: "upList2",
                      on: {
                        clear: function() {
                          this$1.$refs.up4.clearFile()
                        },
                        delete: function(e) {
                          this$1.$refs.up4.deleteFile(e)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { float: "left", "padding-left": "20px" }
                      },
                      [
                        _c("TicketTemplateSelect", {
                          on: { selected: _vm.onTicketTemplateSelected }
                        }),
                        _vm._v(" "),
                        _c("TicketUpload", {
                          ref: "up4",
                          on: {
                            change: function(e) {
                              this$1.$refs.upList2.setAttachmentList(e)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.batchReplyDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    _c("ReplyTicketButton", {
                      on: { click: _vm.postBatchReply }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "批量修改工单类型",
                  visible: _vm.batchUpdateTicketTypeDialogVisible,
                  "close-on-press-escape": false,
                  "close-on-click-modal": false,
                  width: "60%"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.batchUpdateTicketTypeDialogVisible = $event
                  }
                }
              },
              [
                _c("MobileTicketTypePicker", {
                  staticStyle: {
                    "margin-left": "35px",
                    "margin-bottom": "35px"
                  },
                  model: {
                    value: _vm.ticketType,
                    callback: function($$v) {
                      _vm.ticketType = $$v
                    },
                    expression: "ticketType"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.postBatchUpdateTicketType }
                      },
                      [_vm._v("确定")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.batchUpdateTicketTypeDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("TicketAssignDialog", {
              ref: "ticketAssignDialog",
              on: { submit: _vm.postBatchAssign }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2e9c772", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2e9c772","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketBatchOperationBar.vue
// module id = 954
// module chunks = 75